import { ValueRegistryItem } from '../ValueRegistryItem';
import { ValueRegistryCategory } from '../ValueRegistryCategory';
import { QuestionTypeName } from '../../../classes/learnware/LearnwareEnums';
export class ValueRegistryQuestion extends ValueRegistryCategory {
    label = 'Question';
    constructor(parent) {
        super(parent);
        super.init();
    }
    currentQuestionTypeName = () => new ValueRegistryItem({
        value: ({ question }) => {
            if (!question)
                return QuestionTypeName.MultipleChoice;
            return question.questionType;
        },
    });
}
